import { PaywallAuthErrorCodes, PremiumPaywallSignModes } from "../../../../../../global/paywall/paywallInterfaces";
import { LegalLink } from "../../mobile/premiumCalcalistPaywallMobile";
import { HyperLinkBuilder } from "../../../../../commonComponents/inline/hyperLink"

interface PremiumCalcalistPaywallDesktopSignupEmailProps {
  email: string
  agreesTerms: boolean
  setEmail: (email: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (mode: PremiumPaywallSignModes) => void
  loginWithGoogle: () => void
  loginWithApple: () => void
  sendMail: () => void
  authError: string
  legalLinks: {terms: LegalLink; privacy: LegalLink};
}

const errorMessagesFront: Partial<Record<PaywallAuthErrorCodes, string>> = {
  [PaywallAuthErrorCodes.INVALID_EMAIL]: "כתובת המייל אינה תקינה",
  [PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT]: `חובה לאשר את תנאי השימוש`,
};

const errorMesssagesServer: Partial<Record<PaywallAuthErrorCodes, string>> = {
  [PaywallAuthErrorCodes.EMAIL_ALREADY_EXISTS]: "כתובת המייל כבר קיימת במערכת",
  [PaywallAuthErrorCodes.FAILED_TO_SEND_OTP]: "אירעה שגיאה במערכת, אנא נסו שוב מאוחר יותר",
  [PaywallAuthErrorCodes.ALREADY_SIGNED]:"משתמש קיים במערכת",
  [PaywallAuthErrorCodes.OTP_MAX_ATTEMPTS]: "חרגת ממספר בקשות אימות. יש לפנות לשירות לקוחות",
}



export const PremiumCalcalistPaywallDesktopSignupEmail = (props: PremiumCalcalistPaywallDesktopSignupEmailProps) => {

  const { email, setEmail, agreesTerms, setAgreesTerms, loginWithApple, loginWithGoogle, setMode, sendMail, authError,legalLinks } = props

  const handleMailChange = (e) => {
    setEmail(e.target.value)
  }

  const handleAgreeChange = (e) => {
    setAgreesTerms(e.target.checked)
  }

  const handleSendMail = () => {
    sendMail()
  }

  const handlePressKey = (e) => {
    if (e.key === 'Enter') {
      handleSendMail()
    }
  }

  return (
    <div className="premium-calcalist-paywall-desktop-signup-email">
      <div className="digital-edition-label">המהדורה הדיגיטלית</div>
      <h1 className="title">יצירת חשבון חדש</h1>
      <div className="subtitle">צרו חשבון לקריאת המהדורה הדיגיטלית <span className='bold'>לשבועיים מתנה!</span></div>
      <div className={`email-signup ${authError && authError.includes('EMAIL') ? 'error' : ''}`}>
        <input onKeyDown={handlePressKey} value={email} onChange={handleMailChange} type="email" placeholder="הקלידו כתובת מייל" />
       {email && <div className="reset-icon" onClick={() => setEmail('')}></div>}
        {authError && authError === PaywallAuthErrorCodes.INVALID_EMAIL && <p className="error-text">{errorMessagesFront[authError]}</p>}
      </div>
      <div className={`terms ${authError && authError === PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT ? 'error' : ''}`}>
        <div className="inner-container">
          <input type="checkbox" checked={agreesTerms} onChange={handleAgreeChange} />
          <span className="text">מסכים/ה ל<HyperLinkBuilder  linkTarget={legalLinks.terms.target} href={legalLinks.terms.url}>תנאי השימוש</HyperLinkBuilder>, <HyperLinkBuilder  linkTarget={legalLinks.privacy.target} href={legalLinks.privacy.url}>מדיניות פרטיות</HyperLinkBuilder>, וקבלת פניות שיווקיות כולל טלפוניות.<br />הודעות תפעוליות ימשיכו להישלח בתקופת המנוי גם לאחר הסרתי מרשימת מדוורים.</span>
        </div>
        {authError && authError === PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT && <p className="error-text" dangerouslySetInnerHTML={{ __html: errorMessagesFront[authError] }}></p>}
      </div>

      <div className="buttons-container">
        <button className="button-base continue" onClick={handleSendMail}>המשך</button>
      </div>
      {authError && <p className="error-text" dangerouslySetInnerHTML={{ __html: errorMesssagesServer[authError] }}></p>}


      <div className="separator">
        <span className="text">או הירשמו באמצעות</span>
      </div>


      <div className="social-signup">
        <button className="social-button google-btn" onClick={loginWithGoogle}><span>גוגל</span></button>
        <button className="social-button apple-btn" onClick={loginWithApple}><span>אפל</span></button>
      </div>

      <div className="login">
        <div>כבר נרשמתם? <a href="#" onClick={() => setMode("signIn")}>כניסה</a></div>
      </div>
      <div className="newspapper-users" >
        <div>
          <span>טרם נרשמתם אבל מנויים של</span> <span className="calcalist-label"></span>?
          <span className="login"><a href="#" onClick={() => setMode("signIn")}>לחצו כאן להתחברות</a></span>
        </div>
      </div>
      <div className="bottom-logo"></div>
    </div>
    
  )
}
